import React from 'react';
import AmcqResultsView from './AmcqResultsView';

function TeacherStudentResultsAMCQ() {
  return <AmcqResultsView userType="teacher" />;
}

export default TeacherStudentResultsAMCQ;
